export default {
    // Undo notification bar is shown
    SendBarShown: {
        datapoint: {
            name: 'UndoSend_SendBarShown',
        },
    },

    // Undo is activated to cancel send
    SendCancelled: {
        datapoint: {
            name: 'UndoSend_SendCancelled',
        },
    },

    // Amount of time elapsed between Undo being shown and activated
    SendCancelledTimeElapsed: {
        datapoint: {
            name: 'UndoSend_SendCancelledTimeElapsed',
        },
    },
};
